import React, { useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";

import EvaluateApplicantForm from "../../../../components/Events/Event/Evaluations/EvaluateApplicantForm";
import { ROUTE_PATHS } from "../../../../utils/RoutesPaths";
import { EVENT_TABS } from "../../../../components/Events/Event";
import {
  getCompanyEvaluationFormRequest,
  submitCompanyEvaluationFormRequest,
} from "../../../../store/CompanyPortal/Evaluations/actions";

// Admin-portal variant of Company-portal/Events/EvaluateApplicant: same shared
// form + the same redux actions, which branch to the supervisor (UserApp)
// endpoints internally (see CompanyPortal/Evaluations/sagas.js) — only the
// breadcrumb/navigation targets differ here.
const EvaluateApplicant = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const { applicant, round, event } = state || {};
  const formDetails = useSelector((s) => s.companyEvaluations.formDetails);

  useEffect(() => {
    if (applicant?.id) {
      dispatch(getCompanyEvaluationFormRequest({ id: applicant.id }));
    }
  }, [dispatch, applicant]);

  if (!applicant || !round) {
    history.replace(ROUTE_PATHS.events);
    return null;
  }

  const handleSubmit = (data) => {
    dispatch(
      submitCompanyEvaluationFormRequest({
        id: applicant.id,
        data,
        onSuccess: () => handleNavigateToRound(),
      }),
    );
  };

  const handleCancel = () => {
    history.goBack();
  };

  const handleNavigateToEvent = () => {
    if (!event?.id) return;
    history.push(ROUTE_PATHS.viewEvent.replace(":id", event.id));
  };

  const handleNavigateToEvaluations = () => {
    if (!event?.id) return;
    history.push({
      pathname: ROUTE_PATHS.viewEvent.replace(":id", event.id),
      state: { initialTab: EVENT_TABS.evaluations },
    });
  };

  const handleNavigateToRound = () => {
    if (!event?.id) return;
    history.push({
      pathname: ROUTE_PATHS.viewEvent.replace(":id", event.id),
      state: { initialTab: EVENT_TABS.evaluations, selectedRound: round },
    });
  };

  // Wait for the form questions before rendering the rating form so it mounts
  // with the full criteria set (RatingForm seeds its state once).
  if (!formDetails || String(formDetails.id) !== String(applicant.id)) {
    return null;
  }

  return (
    <Box
      sx={{
        marginTop: "var(--space-32)",
        display: "flex",
        flexDirection: "column",
        gap: "var(--space-16)",
        paddingBottom: "var(--space-32)",
      }}
    >
      <EvaluateApplicantForm
        applicant={applicant}
        round={round}
        event={event}
        questions={formDetails.questions}
        eventsListPath={ROUTE_PATHS.events}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
        onNavigateToEvent={handleNavigateToEvent}
        onNavigateToEvaluations={handleNavigateToEvaluations}
        onNavigateToRound={handleNavigateToRound}
      />
    </Box>
  );
};

export default EvaluateApplicant;
